var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#computer_svg__clip0_3541_1983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.127 1.608c-2.696 0-4.889 2.018-4.889 4.5v20.25c0 2.482 2.193 4.5 4.89 4.5h13.444l-.818 2.25H12.46c-1.352 0-2.444 1.006-2.444 2.25 0 1.245 1.092 2.25 2.444 2.25h19.556c1.352 0 2.445-1.005 2.445-2.25 0-1.244-1.093-2.25-2.445-2.25h-5.294l-.817-2.25h13.444c2.697 0 4.89-2.018 4.89-4.5V6.108c0-2.482-2.193-4.5-4.89-4.5H5.127zm34.222 4.5v15.75H5.127V6.108H39.35z",
    fill: "#FFFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "computer_svg__clip0_3541_1983"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.174 .608)",
    d: "M0 0h45.582v36.466H0z"
  })))));
}
export default SvgComputer;